
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import { NavigationTree } from '@/models/Navigation';
import { computed, ComputedRef, defineComponent } from 'vue';

export default defineComponent({
  name: 'BCXNavigationItem',
  components: { BCXIcon },
  props: {
    value: {
      type: Object as () => NavigationTree,
      default: () => ({} as NavigationTree),
    },
    level: {
      type: Number as () => number,
      default: 0,
    },
  },
  setup(props) {
    const { value } = props as { value: NavigationTree }; // value is already a reactive object
    const { isMobileLayout } = useResponsiveness();

    const addedClass: ComputedRef<{ [key: string]: boolean } | null> = computed(() => (value?._class ? { [value._class]: true } : null));

    return {
      addedClass,
      isMobileLayout,
    };
  },
});
